import { css } from 'emotion'

export const UploadFilesCardStyles = css`
  > button {
    padding: 0px 8px;
  }
`
